import styled from 'styled-components';

export const Title = styled.h1`
  font-family: 'Roboto';
  font-weight: 500;
  font-size: 30px;
  line-height: 35px;
  color: #404040;
  opacity: 0.9;

  @media screen and (max-width: 768px) {
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #000000;
  }
`;

export const CdAtivo = styled.div`
  font-family: 'Roboto';
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: #010101;
  opacity: 0.7;
  margin-bottom: 15px;

  @media screen and (max-width: 768px) {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: #595959;
  }
`;

export const Container = styled.div`
  margin-top: 24px;
  padding: 24px;
  background-color: ${(props) => props.theme.colors.primary};
  .rbc-row.rbc-time-header-cell.rbc-time-header-cell-single-day {
    display: none;
  }
`;
